import DataResource from '../../common/v4/DataResource'
import Panel from '../../common/layout/Panel'

export default function AutomationsIndex(props) {
    const data = {
        url: '/admin/automations',
        data: {
            data: [],
            metadata: []
        },
        onclick: 'link',
        link: '/automations/{id}',
        userfilter:[
            {
                source: 'name',
                label: 'Name',
                type: 'text',
                default: ''
            },
            {
                source: 'trigger_type',
                label: 'Trigger Type',
                type: 'select',
                default: ''
            },
            {
                source: 'status',
                label: 'Status',
                type: 'select',
                default: ''
            }
        ],
        metadata: [
            {
                label: 'id',
                source: 'id',
                type: 'primary',
                editable: false,
                visible: false
            },
            {
                label: 'Name',
                source: 'name',
                type: 'text',
                editable: false,
                default: '',
                placeholder: ''
            },
            {
                label: 'Trigger Type',
                source: 'trigger_type',
                type: 'text',
                editable: false,
                default: '',
                placeholder: ''
            },
            {
                label: 'Trigger Details',
                source: 'trigger_details',
                type: 'text',
                editable: false,
                default: '',
                placeholder: ''
            },
            {
                label: 'Steps',
                source: 'step_count',
                type: 'number',
                editable: false,
                default: 0
            },
            {
                label: 'Created By',
                source: 'created_by',
                type: 'text',
                editable: false,
                default: '',
                placeholder: ''
            },
            {
                label: 'Created At',
                source: 'created_at',
                type: 'datetime'
            },
            {
                label: 'Last Modified',
                source: 'updated_at',
                type: 'datetime'
            },
            {
                label: 'Status',
                source: 'status',
                type: 'boolean',
                editable: true,
                default: true,
                values: {
                    true: 'Active',
                    false: 'Inactive'
                },
                classnames: {
                    true: 'label label-success',
                    false: 'label label-danger'
                }
            },
            {
                label: 'Delete',
                type: 'delete',
            }
        ]
    }
    
    return (
        <Panel title="Automations">
            <DataResource
                addButtonText="Create New Automation"
                addButtonType="link"
                addButtonLink="/automations/create"
                data={data}
                {...props}
            />
        </Panel>
    );
} 